import React from 'react';
import { InvoiceStatus } from '../types';

interface InvoiceMetaGridProps {
  clientName: string;
  issueDate: string;
  invoiceId: string;
  status: InvoiceStatus;
}

const STATUS_CLASS: Record<InvoiceStatus, string> = {
  Paid: 'invoice-details-modal__status--paid',
  Pending: 'invoice-details-modal__status--pending',
  Overdue: 'invoice-details-modal__status--overdue',
  Draft: 'invoice-details-modal__status--draft',
};

export const InvoiceMetaGrid: React.FC<InvoiceMetaGridProps> = ({
  clientName,
  issueDate,
  invoiceId,
  status,
}) => (
  <div className="invoice-details-modal__meta-grid">
    <div>
      <span>Client Name</span>
      <strong>{clientName}</strong>
    </div>
    <div>
      <span>Issue Date</span>
      <strong>{issueDate}</strong>
    </div>
    <div>
      <span>Invoice ID</span>
      <strong>{invoiceId}</strong>
    </div>
    <div>
      <span>Status</span>
      <span className={`invoice-details-modal__status ${STATUS_CLASS[status]}`}>
        {status}
      </span>
    </div>
  </div>
);
